import { Duration, intervalToDuration } from 'date-fns';
import { useEffect, useState } from 'react';
import { TimerFrame, sharedDateTimer } from './timer.hooks';

export const useNow = () => {
  const [now, setNow] = useState(sharedDateTimer.now);
  useEffect(() => {
    const onTimerFrame = (frame: TimerFrame) => setNow(frame.now);
    sharedDateTimer.subscribe(onTimerFrame);
    return () => sharedDateTimer.unsubscribe(onTimerFrame);
  }, []);
  return now;
};

export type Countdown = Required<Pick<Duration, 'days' | 'hours' | 'minutes' | 'seconds'>> & {
  total: number;
};
export const useCountdown = (end: Date = sharedDateTimer.now): Countdown => {
  const start = useNow();
  return getCountdown(end, start);
};

export const getCountdown = (end: Date, start = sharedDateTimer.now): Countdown => {
  const total = Math.round((end.getTime() - start.getTime()) / 1000);

  const duration =
    total <= 0 ? { days: 0, hours: 0, minutes: 0, seconds: 0 } : intervalToDuration({ start, end });

  return {
    days: (duration.months || 0) * 30 + (duration.days || 0),
    hours: duration.hours || 0,
    minutes: duration.minutes || 0,
    seconds: duration.seconds || 0,
    total,
  };
};
